import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const ProtectedRoute = ({ children, allowedRoles }) => {
    const token = localStorage.getItem('token');

    if (!token) {
        return <Navigate to="/" />;

    }

    try {
        const decodedToken = jwtDecode(token);
        const userRole = decodedToken.roles;

        if (!allowedRoles.includes(userRole)) {
            return <Navigate to="/" />;
        }

        return children;
    } catch (error) {
        console.error('Invalid token:', error);
        return <Navigate to="/" />;
    }
};

export default ProtectedRoute;
